import { enumToI18nKey } from "~/utils/helpers";

export const KEY_PURPOSE = {
  INBOUND_VT_VERIFY_KEY: "Inbound VT Verify Key",
  INBOUND_VT_SIGN_KEY: "Inbound VT Sign Key",
  CLIENT_API_AUTHORIZE_VERIFY_KEY: 'Client API Authorize Verify Key',
} as { [key: string]: KeyManagementApi.eKeyPurpose };

export const KEY_PURPOSE_I18n = enumToI18nKey(KEY_PURPOSE, "KEY_PURPOSE");
